module.exports = __webpack_public_path__ + "static/media/icon_relativeFinder_inactive.f720d250.svg";